<template>
  <div id="app" class="app" :class="[$route.path.match(/gogatsu/) ? 'app-gogatsu' : 'app-hina']">
    <v-header/>
    <div v-if="stateAuthority === 'admin'" class="app__authority">管理者モード</div>
    <v-pwa-message/>

    <transition name="animation-fade-up" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>



<script>
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import router from './router/index'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      stateAuthority: state => state.page.authority,
    })
  },
  components: {
    'v-header': require('@/components/header.vue').default,
    'v-pwa-message': require('@/components/pwa-message.vue').default,
  },
  mounted() {
    this.windowResize()
    this.authority()
    window.addEventListener('resize', () => {
      this.windowResize()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.windowResize()
    })
  },
  methods: {
    windowResize() {
      this.$store.commit('window/widthSet', window.innerWidth)
    },
    authority() {
      axios.get('/api/check_login/admin')
        .then(response => {
          if (response.data.login) {
            this.$store.commit('page/authoritySet', 'admin')
          } else {
            this.$store.commit('page/authoritySet', 'guest')
            console.log('guest');
            this.analytics()
          }
        })
    },
    analytics() {
      Vue.use(VueAnalytics, {
        id: 'UA-10584816-1',
        router,
        ecommerce: {
          enabled: true,
          enhanced: true
        },
        autoTracking: {
          shouldRouterUpdate (to, from) {
            return to.path !== from.path
          }
        },
      })
    }
  }
}
</script>



<style lang="scss">
@import "./assets/scss/style";

.app {
  position: relative;
  height: 100%;
  &__authority {
    position: fixed;
    right: 0;
    top: 0;
    z-index: map-get($z-index, authority);
    border-bottom-left-radius: 4px;
    background-color: $oc-gray-8;
    font-size: 13px;
    color: #fff;
    padding: 8px 12px;
  }
}
</style>
